import {
  aggregationCampaignsSchema,
  aggregationCompaniesSchema,
  aggregationEndDateTimeSchema,
  aggregationShopsSchema,
  aggregationStartDateTimeSchema,
  aggregationWalletServicesSchema,
} from './aggregation';

import { CampaignAggregationCriteriaKey } from '@/types';
import {
  InferType,
  object,
  string,
} from '@/validations/custom-yup';

export const campaignAggregationCriteriaSchema = string<CampaignAggregationCriteriaKey>()
  .label('集計基準')
  .required(({ label }) => `${label}を選択してください。`);

export const campaignAggregationFilterSchema = object({
  walletServices: aggregationWalletServicesSchema,
  companies: aggregationCompaniesSchema,
  shops: aggregationShopsSchema,
  campaigns: aggregationCampaignsSchema,
});

export type CampaignAggregationFilterSchema = InferType<typeof campaignAggregationFilterSchema>;

export const campaignAggregationUiFormSchema = object({
  startDateTime: aggregationStartDateTimeSchema,
  endDateTime: aggregationEndDateTimeSchema,
  criteria: campaignAggregationCriteriaSchema,
  filter: campaignAggregationFilterSchema,
});

export type CampaignAggregationUiFormSchema = InferType<typeof campaignAggregationUiFormSchema>;
